import { render, staticRenderFns } from "./TextEfx.vue?vue&type=template&id=43b3173c&scoped=true&"
import script from "./TextEfx.vue?vue&type=script&lang=js&"
export * from "./TextEfx.vue?vue&type=script&lang=js&"
import style0 from "./TextEfx.vue?vue&type=style&index=0&id=43b3173c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3173c",
  null
  
)

export default component.exports